'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var moduleName = 'appFactories';

angular.module(moduleName, ['ngCookies'])
    .factory('UserService', ['$rootScope', 'ApiService', require('./services/user')])
    .factory('CifService', ['$rootScope',require('./services/cif')])
    .factory('FlashService', ['$rootScope', '$mdToast', '$filter', require('./services/flash')])
    .factory('AuthenticationService', ['$http', '$cookieStore', '$rootScope', 'Api', require('./services/authentication')]);

exports.default = moduleName;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./js/services.js
 **/